/* eslint-disable import/no-unresolved,react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useHistory, useLocation } from 'react-router-dom';
import { SecurityTOTPBodyLayout } from 'assets/components';

const TOTPMain = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const { state } = useLocation();

  useEffect(() => {
    if (!state?.email && !state?.username) {
      history.push('/onboarding/login');
    }
  }, []);

  const renderButtons = () => (
    <div className="d-flex flex-row gap-4 w-100">
      {state?.signupFlow && (
        <button
          type="button"
          className="btn border-grey border text-white py-3 w-100 text-bold"
          onClick={() => history.push(`/`, { showPromo: true })}>
          {translate('general_skip')}
        </button>
      )}
      <button
        className="btn btn-primary w-100 py-3 text-bold"
        onClick={() => {
          history.push(`/onboarding/totp-secret`, { ...state });
        }}
        type="button">
        {translate('generic_next')}
      </button>
    </div>
  );

  return (
    <SecurityTOTPBodyLayout
      title={translate('totp_main_title')}
      renderButtons={renderButtons}
      withCloseBtn={state?.signupFlow}
      onClose={state?.signupFlow ? () => history.push(`/`, { showPromo: true }) : null}>
      <div className="d-flex flex-column justify-content-center align-items-center h-75 mt-3 mt-md-4">
        <img src="./assets/images/auth.png" className={` mt-5 mt-md-0`} alt="Auth" />
        <div className="d-flex flex-column justify-content-center align-items-center px-3 mt-4">
          <p className="text-dark text-f5 text-center text-bold px-md-5 mx-md-5">
            {translate('totp_step_1_title')}
          </p>
        </div>
        <div className="d-flex flex-row justify-content-between  align-items-center mt-4 gap-1 gap-md-4">
          <img src="./assets/images/app-store.png" style={{ width: '10rem' }} alt="Auth" />
          <img src="./assets/images/google-play.png" style={{ width: '10rem' }} alt="Auth" />
        </div>

        {/* only browser */}
        <p className="d-none d-md-block text-shadow text-f5 text-center mt-4">
          {translate('totp_main_note')}
        </p>

        {/* only mobile */}
        <div className="d-flex d-md-none flex-column h-100 justify-content-center">
          <p className="text-shadow text-f5 text-center">{translate('totp_main_note')}</p>
        </div>
      </div>
    </SecurityTOTPBodyLayout>
  );
};

export default TOTPMain;
